'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/wanDnsPlaceholder/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of default DNS configuration.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/wanDnsPlaceholder/StaticView#model
   * @type {actions/wanDnsPlaceholder/EditWanDns}
   */

  template: twig({data: tpl}),
});
